// Version : 0.0.1
// Author : NANDHA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:25-09-2025

import BranchCollectionReportActionTypes from './branch-collection-report.type';
/** ***************** GET BRANCH COLLECTION REPORT START *********************** */
export const getBranchCollectionReportDetailsStart = (getData: any) => ({
	type: BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_START,
	payload: getData,
});

export const getBranchCollectionReportDetailsSuccess = (successData: any) => ({
	type: BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getBranchCollectionReportDetailsFailure = (failureData: any) => ({
	type: BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getBranchCollectionReportDetailsResponseResetStart = () => ({
	type: BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_RESPONSE_RESET,
});

export const getBranchCollectionReportDetailsResponseChanged = () => ({
	type: BranchCollectionReportActionTypes.GET_BRANCH_COLLECTION_REPORT_LIST_RESPONSE_CHANGED,
});
/** ***************** GET BRANCH COLLECTION REPORT END *********************** */
